import { Component } from '@angular/core';

@Component({
  selector: 'app-main-deductions-menu',
  templateUrl: './main-deductions-menu.component.html',
  styleUrls: ['./main-deductions-menu.component.css'],
})
export class MainDeductionsMenuComponent {}
